export default {
    PENDIENTE: 0,
    ACEPTADO: 1,
    NO_ACEPTADO: 2
}
